import { ReportOfferReason } from 'logic/api-models/report-offer';
import React, { FC } from 'react';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Radio } from 'antd';

interface ReasonCheckboxProps {
  reason: ReportOfferReason;
}

export const ReasonRadioInput: FC<ReasonCheckboxProps> = ({ reason }) => {
  return (
    <span>
      <Radio value={reason}>
        <Text>{translate(translationKeys.reportOffer.reasons[reason])}</Text>
      </Radio>
    </span>
  );
};
